import { useMsal } from '@azure/msal-react';
import getAuthAPIInstance from './AuthApi';

export const useAuthEvents = () => {
  const { instance } = useMsal();

  return getAuthAPIInstance(instance);
};
